// Enhanced Conversions support for the dashboard's Google Ads conversion events.
//
// Attaches the buyer's identity to a conversion so it still matches when third-party cookies are
// unavailable, which is most of the time now. Typically recovers a meaningful share of conversions
// that would otherwise go unattributed.
//
// The email is passed in the clear to gtag ON PURPOSE — gtag normalizes and SHA-256 hashes it
// locally before anything leaves the browser, so no plaintext address is transmitted.
//
// Two things have to be true for this to do anything, and neither is sufficient alone: the AW-
// destination must be configured with allow_enhanced_conversions (see plugins/google-analytics.js),
// and this must be called BEFORE the conversion event — gtag applies user_data to subsequent hits,
// so setting it afterwards attaches it to nothing.

// vue-gtag's set() forwards its arguments straight through as gtag('set', ...args), so the
// two-argument named form below produces gtag('set', 'user_data', {...}) — the shape Enhanced
// Conversions requires. Passing a single object instead would emit gtag('set', {user_data: ...}),
// which is a different call that Google ignores for this purpose.
export function setUserData(gtag, email) {
  if (!gtag || !email) return;
  gtag.set('user_data', { email: String(email).trim().toLowerCase() });
}
